"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(_ref) {
  var language = _ref.language;
  return language;
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfZGVmYXVsdCIsIl9yZWYiLCJsYW5ndWFnZSIsImV4cG9ydHMiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VsZWN0b3JzL2xhbmd1YWdlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgUmVkdXhTdGF0ZSB9IGZyb20gJy4uL3R5cGVzL2ludGVybmFsL1JlZHV4U3RhdGUnO1xuXG5leHBvcnQgZGVmYXVsdCAoeyBsYW5ndWFnZSB9OiBSZWR1eFN0YXRlKTogc3RyaW5nID0+IGxhbmd1YWdlO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7ZUFFZSxTQUFBQSxTQUFBQyxJQUFBO0VBQUEsSUFBR0MsUUFBUSxHQUFBRCxJQUFBLENBQVJDLFFBQVE7RUFBQSxPQUEyQkEsUUFBUTtBQUFBO0FBQUFDLE9BQUEsY0FBQUgsUUFBQSJ9